export default {
  empty:
    'Aucun article disponible dans ce rayon pour votre lieu et date de livraison/récupération.',
};
